import { useEffect } from "react";
import useBusstaitions from "./useBusstaitions";
import useCity from "./useCity";
import useRoadmaps from "./useRoadmaps";
import { useDispatch } from "react-redux";
import { controlLoadingMap, setBusStations, setMapMode } from "../store/mapScreenSlce";
import { useLocation } from "react-router-dom";
import useToastMap from "./useToast";

function useInitMap() {
    const dispatch = useDispatch();
    //const { dataQueryRoute } = useQueryRoute();
    const { fillBusStations } = useBusstaitions();
    const { initCity, getCities } = useCity();
    const { getRoadmapsByBusstaition, selectRoadmapByBusStation, fillRoadmapByQuery } = useRoadmaps();
    const { openToastMap, hideToastMap } = useToastMap();
    //const query = useQuery();
    const location = useLocation();

    async function firstRender() {
        try {
            openToastMap('loading', 'Загрузка')
            dispatch(controlLoadingMap('init')); 
            await Promise.all([
                initCity(),
                getCities('')
            ]);
            dispatch(setMapMode('busStops'));
        }
        catch (err) {
            console.error(err);
        }
        finally {
            dispatch(controlLoadingMap('init'));
            hideToastMap();
        }
    }

    async function queryMode({ routeId, cityId }: { routeId: string; cityId: string }) {
        try {
            if (cityId) {
                openToastMap('loading', 'Загрузка маршрута')
                dispatch(setMapMode('query'));
                await fillRoadmapByQuery(cityId, routeId)
            }
        }
        catch (err) {
            console.log(err);
        }
        finally {
            hideToastMap();
        }
    }

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const cityId = query.get("cityId");
        const routeId = query.get("routeId");
        const NSTOP_ID = query.get("NSTOP_ID");
        if (cityId && routeId) {
            queryMode({ cityId, routeId });
        } else {
            firstRender();
        }
    }, [])

}
export default useInitMap;